// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import ClipboardController from "./clipboard_controller";
import SubmitController from "./submit_controller";

application.register("clipboard", ClipboardController);
application.register("submit", SubmitController);
